import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Film, ImageIcon, ImageOff } from 'lucide-react';
import { cn } from '../lib/cn.js';
/** `sm` — 56 px (строка списка), `tile` — квадрат на всю ширину ячейки сетки. */
const sizeClass = {
    sm: 'h-14 w-14',
    tile: 'aspect-square w-full',
};
export const IMAGE_THUMB_UNAVAILABLE_LABEL_RU = 'превью нет';
/**
 * Превью-картинка с заглушкой: `<img loading="lazy">`, а нет адреса или
 * картинка не загрузилась — квадрат со значком типа. Для видео с
 * наведением-проигрыванием есть `VideoThumb`.
 */
export function ImageThumb({ src, label, kind = 'image', size = 'sm', className, }) {
    const [broken, setBroken] = React.useState(false);
    // другой адрес — новая попытка
    React.useEffect(() => setBroken(false), [src]);
    const box = cn('shrink-0 rounded-[var(--radius-2)]', sizeClass[size], className);
    if (!src || broken) {
        const Icon = kind === 'video' ? Film : kind === 'image' ? ImageIcon : ImageOff;
        return (_jsx("div", { className: cn(box, 'flex items-center justify-center bg-[var(--color-surface-sunken)]'), role: "img", "aria-label": `${label}: ${IMAGE_THUMB_UNAVAILABLE_LABEL_RU}`, children: _jsx(Icon, { "aria-hidden": true, className: "h-6 w-6 text-[var(--color-text-muted)]" }) }));
    }
    return (_jsx("img", { src: src, alt: label, loading: "lazy", onError: () => setBroken(true), className: cn(box, 'bg-[var(--color-surface-sunken)] object-cover') }));
}
//# sourceMappingURL=image-thumb.js.map